<template>
  <!-- 頭部 -->
  <Header></Header>
  <div class="bjhs">
    <div>
      <img class="wx" src="../assets/picture/1920_about.png" alt="" />
     </div>

    <!-- 品牌概述 -->     
    <div class="ppgk">
      <div class="ppgk-title">品牌概況</div>
      <div class="ppgk-describe">
        香港樂滿門床具廠有限公司成立於一九七五年，多年來始終跟隨品質第一，服務至上的宗旨辦企業，使公司以床墊的銷售網絡日漸增大，為進一步滿足客戶的供應需求，本公司於一九九一年在中國大陸增設廠房，拓展生產線，開設椰棕，木工，梳化等多個生產項目，決意以優質價廉的產品為客戶服務，希望廣大客戶繼續支持，為服務社會而共同努力,
        為迎合不同消費者的需要，美的夢推出了六款擁有不同功能的床褥，包括雙面王床褥，以太空記憶棉製造的舒壓型床褥，按身體曲線自行調整的超級型床褥，具高柔軟感的獨立袋裝型床褥，護脊型及特硬型床褥。出乎意料的是，最受歡迎的不是比較舒適，彈簧調整幅度較大的型號，而是感覺上較硬但承托表現更佳的護脊型和特硬型床褥。相信這與近年香港人注重健康及健美的體態有關。凌董事長表示該兩款床褥深受歡迎的原因，主要是其耐用性，價錢大眾化，而且適合普羅大眾市場和中等階層市場。
      </div>
      <div class="pphxjzg-title">品牌核心價值觀</div>
      <div class="pphxjzg-subtitle">
        品質靠前：把產品和質量作為我們的生命線，不斷創新產品，堅守質量標準
      </div>
      <div class="pphxjzg-subtitle">誠信服務：承諾一致，直到讓客戶滿意為止</div>
      <div class="pphxjzg-subtitle">
        綠色環保：不斷優化，節約資源，精選優質環保材料
      </div>
      <div class="pphxjzg-subtitle">追求不凡：對價值和美的不懈追求</div>
    </div>
    <!-- 品牌概述的底圖 -->
    <div>
      <el-image class="ppgk-dt" :src="about3[0]"></el-image>
      <el-image class="ppgk-dt" :src="about3[1]"></el-image>
      <el-image class="ppgk-dt" :src="about3[2]"></el-image>
    </div>
    <!-- 品質承諾 -->
    <div class="pzcn">
      <el-image class="pzcn-image" :src="about4"></el-image>
      <div class="pzcn-wz">
        <div class="pzcn-title">品質承诺</div>
        <div class="pzcn-subtitle">傳統经典與现代科技</div>
        <div class="pzcn-subtitle">
          我們致力於打造具有性價比的環保床具！好床具讓品質成為他的內在性格
        </div>
        <div class="pzcn-yw">
          Traditional classical and modern science and technology We are
          committed to creating the most cost-effective environmental protection
          furniture! Good furniture makes the quality of his inner character
        </div>
      </div>
    </div>
  </div>
  <!-- 底部圖片 -->
  <div class="dt">
    <div class="dt-sbf">
      <div>
        <el-image :src="about5[0]"></el-image>
        <div class="dt-wz">專業的設計和售後團隊</div>
      </div>
      <div>
        <el-image :src="about5[1]"></el-image>
        <div class="dt-wz">恪守經營，以人為本</div>
      </div>
    </div>
    <div>
      <el-image :src="about5[2]"></el-image>
      <div class="dt-wz">對高品質的生活追求</div>
    </div>
  </div>
  <Footer></Footer>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
export default {
  name: "About",
  data() {
    return {
      about_dt: "",
      about2: [
        "https://nicedream.top:8202/gw_lmm/about2-1.png",
        "https://nicedream.top:8202/gw_lmm/about2-2.png",
        "https://nicedream.top:8202/gw_lmm/about2-3.png",
      ],
      about3: [
        "https://nicedream.top:8202/gw_lmm/about3-1.png",
        "https://nicedream.top:8202/gw_lmm/about3-2.png",
        "https://nicedream.top:8202/gw_lmm/about3-3.png",
      ],
      about4: "https://nicedream.top:8202/gw_lmm/about4.jpg",
      about5: [
        "https://nicedream.top:8202/gw_lmm/about5-1.jpg",
        "https://nicedream.top:8202/gw_lmm/about5-2.png",
        "https://nicedream.top:8202/gw_lmm/about5-3.png",
      ],
    };
  },
  components: { Header, Footer },
};
</script>

<style scoped>
/* 等分佈局 */
.dfbj {
  width: 55%;
  display: flex;
  justify-content: space-between;
  margin: 50px auto;
}
.dfbj-card {
  width: 260px;
  height: 100px;
  display: flex;
  justify-content: flex-start;
  background-color: #ffffff;
}
.dfbj-card .el-image {
  width: 60px;
  height: 60px;
  margin: 20px;
}
.dfbj-wz {
  text-align: left;
  margin-top: 25px;
  font-size: 20px;
}
/* 品牌概況 */
.ppgk {
  width: 50%;
  margin: 20px auto;
}
.ppgk-title {
  font-family: 微软雅黑;
  font-size: 38px;
  color: #333333;
  font-weight: bold;
  margin: 30px 0px;
}
.ppgk-describe {
  font-family: 微软雅黑;
  font-size: 16px;
  color: #666666;
  line-height: 33px;
}
.pphxjzg-title {
  text-align: left;
  font-family: 微软雅黑;
  color: #333333;
  font-size: 20px;
  line-height: 120px;
}
.pphxjzg-subtitle {
  text-align: left;
  font-family: 微软雅黑;
  font-size: 16px;
  color: #666666;
  line-height: 40px;
}
.ppgk-dt {
  margin: 20px 15px;
}
/* 品質承諾 */
.pzcn {
  width: 100%;
  height: 600px;
}
.pzcn-image {
  width: 100%;
  height: 600px;
}
.pzcn-wz {
  position: relative;
  width: 50%;
  top: -500px;
  color: #ffff;
  margin: 0 auto;
}
.pzcn-title {
  font-size: 48px;
  margin: 60px 0;
}
.pzcn-subtitle {
  font-size: 20px;
  margin: 30px 0;
}
.pzcn-yw {
  line-height: 35px;
}

/* 底圖 */
.dt {
  padding: 50px 0px;
}
.dt-wz {
  line-height: 60px;
}
.dt-sbf {
  display: flex;
  justify-content: space-between;
  width: 60%;
  margin: 30px auto;
}
</style>